import { api } from '../../../../../lib/api';

export const trackCampaignView = ({ campaignUuid }) => {
  return api({
    method: 'post',
    url: `/api/v1/campaigns/${campaignUuid}/campaign_viewing_events`,
  });
};
